import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { BannerOffers } from './types';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError } from '../../utils/errors';

/** Returns null when settings/bannerOffers does not exist yet. */
export const getBannerOffers = async (): Promise<BannerOffers | null | ProjectErrorType> => {
  try {
    const snapshot = await getDoc(doc(db, 'settings', 'bannerOffers'));
    if (!snapshot.exists()) {
      return null;
    }

    const { enabled, drop, events, weekly, default: defaultEntry } = snapshot.data();
    return { enabled, drop, events: events || [], weekly, default: defaultEntry } as BannerOffers;
  } catch (error) {
    console.log('[BANNER OFFERS] Error at getBannerOffers:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const setBannerOffers = async (data: BannerOffers): Promise<void | ProjectErrorType> => {
  try {
    await setDoc(doc(db, 'settings', 'bannerOffers'), { ...data, updatedAt: serverTimestamp() });
  } catch (error) {
    console.log('[BANNER OFFERS] Error at setBannerOffers:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
